import MoveTo from 'moveto';

import { isVisible, showLoader, hideLoader } from './utils/utils';
import { commentFormSubmit } from './general/comments';
import { sendQuestion } from './question-form';

const findFirstVisible = (toValidate) => {
    const invalids = Array.prototype.slice.call(toValidate.querySelectorAll('.invalid'));
    return invalids.find((item) => isVisible(item));
}

var match = window.navigator.userAgent.match(/Firefox\/([0-9]+)\./);

if (match) {
    var ver = match ? parseInt(match[1]) : 0;

    if (ver < 85) {
        document.body.classList.add('older-browser');
    }
}

export default function (toValidateList) {

    class Validator {
        constructor(toValidate) {
            this.toValidate = toValidate;

            this.init();
            this.applyEvents();

            //IMask
            const maskedFields = this.toValidate.querySelectorAll('[data-masked-field]');

            if (maskedFields.length > 0) {
                function checkRealValue(mF) {
                    const realValue = mF._unmaskedValue;
                    const realNeeded = mF.masked._blocks.filter(charObj => charObj.isOptional === false);

                    if (realValue.length !== realNeeded.length) {
                        return false;
                    } else {
                        return true;
                    }
                }

                import('imask').then((module) => {
                    maskedFields.forEach(field => {
                        const maskOptions = {
                            mask: field.getAttribute('data-masked-field'),
                            lazy: false
                        };
                        const maskedField = module.default(field, maskOptions);

                        maskedField.on('complete', () => {
                            this.markAsValid(field);
                        });

                        maskedField.on('accept', () => {
                            if (field.parentElement.classList.contains('valid')) {
                                this.markAsInvalid(field);
                            }
                        });

                        field.addEventListener('focusout', () => {
                            if (!checkRealValue(maskedField)) {
                                this.markAsInvalid(field);
                            }
                            if (maskedField._unmaskedValue === "") {
                                field.parentElement.classList.remove('invalid');
                            }
                        });

                        field.addEventListener('mask-submit', () => {
                            if (!field.parentElement.classList.contains('valid')) {
                                this.markAsInvalid(field);
                            }
                        });

                        this.checkFilled(field);
                        if (field.parentElement.classList.contains('filled') && checkRealValue(maskedField)) {
                            this.markAsValid(field);
                        }
                    });
                });
            }
        }

        init() {
            this.allFields = [...this.toValidate.querySelectorAll('.field-wrapper')].map(fieldWrapper => fieldWrapper.firstElementChild);

            // Wymagane do walidacji
            this.required = [...this.toValidate.querySelectorAll('[data-validator*="required"]')];

            // Pola typu tekstowego
            this.inputFields = this.allFields.filter(field => {
                return field.type === 'text' ||
                    field.type === 'textarea' ||
                    field.type === 'password' ||
                    field.type === 'email';
            });

            // Checkbox
            this.checkboxes = this.required.filter(required => required.type === 'checkbox');

            // Select
            this.selects = this.allFields.filter(field => field.type === 'select-one');

            // Nadanie klasy 'filled' wypełnionym początkowo polom
            [...this.inputFields, ...this.selects].forEach(field => {
                this.checkFilled(field);
                if (field.parentElement.classList.contains('filled')) {
                    this.processField(field);
                }
            });
        }

        applyEvents() {
            this.inputFields.forEach(inputField => {
                inputField.addEventListener('input', (e) => {
                    if (e.target.hasAttribute('data-masked-field')) return;
                    this.processField(e.target);
                });

                inputField.addEventListener('focusin', (e) => {
                    if (e.target.hasAttribute('data-masked-field')) return;
                    this.checkFilled(e.target);
                    this.processField(e.target);
                });

                inputField.addEventListener('focusout', (e) => {
                    this.checkFilled(e.target);
                });
            });

            [...this.checkboxes, ...this.selects].forEach(checkbox => {
                checkbox.addEventListener('change', (e) => {
                    this.processField(e.target);
                });
            });

            // Form
            if (this.toValidate.tagName === 'FORM') {
                this.toValidate.addEventListener('submit', (e) => this.submitForm(e));
            }
        }

        processField(field) {
            if (field.hasAttribute('data-validator')) {
                const validations = field.getAttribute('data-validator').split(', ');
                const numberOfValidations = validations.length;
                let passedObj;
                let message;

                if (field.hasAttribute('data-sanitize')) {
                    const sanitizationsArr = field.getAttribute('data-sanitize').split(', ');
                    const numberOfSanitizations = sanitizationsArr.length;

                    for (let i = 0; i < numberOfSanitizations; i++) {
                        if (this.sanitizations[sanitizationsArr[i]] === undefined) continue;
                        const fieldTemp = field;
                        fieldTemp.value = this.sanitizations[sanitizationsArr[i]](field.value);
                    }
                }

                if (!field.hasAttribute('data-masked-field')) {
                    for (let i = 0; i < numberOfValidations; i++) {
                        if (validations[i] === 'required') continue;

                        if (validations[i].startsWith('text')) {
                            const values = validations[i].split('-');
                            passedObj = this.rules['text'](field, values[1], values[2]);
                        } else {
                            passedObj = this.rules[validations[i]](field);
                        }

                        if (!passedObj.passed) {
                            message = passedObj.message;
                            this.markAsInvalid(field, message);
                            break;
                        }
                    }

                    if (!message) {
                        this.markAsValid(field);
                    } else {
                        this.updateMessageText(field, message);
                    }
                } else {
                    field.dispatchEvent(new CustomEvent('mask-submit'));
                }
            } else if (field.type === 'select-one') {
                let passedObj = this.rules['select'](field);
                let message;

                if (!passedObj.passed) {
                    message = passedObj.message;
                    this.markAsInvalid(field, message);
                } else {
                    this.markAsValid(field);
                }
            }
        }

        markAsInvalid(field, message) {
            const parent = field.parentNode;

            if (!parent.classList.contains('invalid')) {
                if (message) {
                    const hint = document.createElement('div');
                    hint.className = 'form-hint';
                    hint.innerText = message;
                    parent.appendChild(hint);
                }

                parent.classList.remove('valid');
                parent.classList.add('invalid');
            }
        };

        updateMessageText(field, message) {
            field.parentNode.querySelector('.form-hint').innerText = message;
        };

        markAsValid(field) {
            const parent = field.parentNode;
            const elem = parent.querySelector('.form-hint');

            parent.classList.remove('invalid');
            parent.classList.add('valid');

            if (elem) {
                parent.removeChild(elem);
            }

            this.checkFilled(field);
        };

        checkFilled(field) {
            if (field.type === 'select-one') {

                if (field.value !== '') {
                    field.parentElement.classList.add('filled');
                }

                return;
            }

            if (field.value !== '') {
                field.parentElement.classList.add('filled');
            } else {
                field.parentElement.classList.remove('filled');
            }
        }

        submitForm(e) {
            const isModal = window.currentModalInstance;
            const fields = this.required;
            const visibleFields = fields.filter((field) => isVisible(field.parentNode));

            if (!visibleFields.every((field) => field.parentNode.classList.contains('valid'))) {
                e.preventDefault();

                const isCartPage = document.body.getAttribute('data-type') === 'cart';

                fields.forEach((field) => {
                    this.processField(field);

                    if (field.type === 'select-one') return;
                    field.parentNode.classList.add('filled');
                });

                if (!isModal) {
                    const moveTo = new MoveTo({ tolerance: (isCartPage ? 30 : window.scrollOffset) });
                    const target = findFirstVisible(this.toValidate);

                    moveTo.move(target);
                }
                return;
            }

            if (document.querySelector('.cart-side-summary')) {
                const submitSideButton = document.querySelector('.cart-side-summary .confirm-button');
                if (submitSideButton) {
                    submitSideButton.classList.add('button-disabled');
                }
            }

            const formSubmitType = this.toValidate.getAttribute('data-run-validator');

            switch (formSubmitType) {
                case 'comment-product-form':
                    e.preventDefault();
                    commentFormSubmit(this.toValidate);
                    break;
                case 'ask-question-form':
                    e.preventDefault();
                    sendQuestion(this.toValidate);
                    break;
            }

            if (this.toValidate.getAttribute('data-submitting') === '1') {
                e.preventDefault();
            }

            this.toValidate.setAttribute('data-submitting', '1');
            showLoader();
        }

        // Formatowanie przed walidacją
        sanitizations = {
            trim: (field) => {
                return field.trim();
            },
            toUpperCase: (field) => {
                return field.toUpperCase();
            }
        }

        // Walidacje
        rules = {
            text: (field, minValue, maxValue) => {
                const tempString = field.value.replace(/ /g, "");

                const currentLength = tempString.length;
                const minMax = !!maxValue;

                return {
                    passed: minMax ? (currentLength >= minValue && currentLength <= maxValue) : (currentLength >= minValue),
                    message: field.dataset.validatorMessage || (minMax ? `Min. znaków: ${minValue}, maks. znaków: ${maxValue}` : `Min. znaków: ${minValue}`)
                };
            },
            email: (field) => {
                return {
                    passed: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i.test(field.value),
                    message: field.dataset.validatorMessage || 'Podaj prawidłowy email'
                };
            },
            phone: (field) => {
                let passed = false;
                let message = false;
                const str = field.value || '0';
                const test = str.match(/(\d){1}/g);

                if (test && test.length >= 9) {
                    passed = true;
                } else {
                    message = field.dataset.validatorMessage || 'Podaj numer telefonu';
                }

                return {
                    passed: passed,
                    message: message
                };
            },
            zip: (field) => {
                let passed = false;
                let message = false;
                const str = field.value || "0";
                const test = str.match(/(\d){1}/g);

                if (test && test.length === 5) {
                    passed = true;
                } else {
                    message = field.dataset.validatorMessage || 'Podaj kod pocztowy';
                }

                return {
                    passed: passed,
                    message: message
                };
            },
            nip: (field) => {
                let passed = false;
                let message = false;
                const nip = field.value;

                const validateNIP = (nip) => {
                    if (nip === null)
                        return false;
                    nip = nip.replace(/\-/g, '');
                    if (nip.length !== 10)
                        return false;

                    for (var i = 0; i < 10; i++)
                        if (isNaN(nip[i]))
                            return false;

                    let sum = 6 * nip[0] +
                        5 * nip[1] +
                        7 * nip[2] +
                        2 * nip[3] +
                        3 * nip[4] +
                        4 * nip[5] +
                        5 * nip[6] +
                        6 * nip[7] +
                        7 * nip[8];
                    sum %= 11;
                    if (parseInt(nip[9]) !== sum)
                        return false;

                    return true;
                }

                if (validateNIP(nip)) {
                    passed = true;
                } else {
                    message = field.dataset.validatorMessage || 'Podaj prawidłowy NIP';
                }

                return {
                    passed: passed,
                    message: message
                };
            },
            checkbox: (field) => {
                return {
                    passed: field.checked,
                    message: field.dataset.validatorMessage || 'Akceptacja jest wymagana, aby przejść dalej'
                };
            },
            select: (field) => {
                return {
                    passed: field.value !== '',
                    message: 'Wybierz jedną z opcji'
                };
            },
            password(field) {
                this.comparison(field);

                return {
                    passed: /^([^\s]){5,}$/i.test(field.value),
                    message: field.dataset.validatorMessage || 'Co najmniej 5 znaków (bez spacji)'
                };
            },
            comparison: (field) => {
                let passed = false;
                let message = false;

                if (field.dataset.comparison) {
                    const fieldToCompare = this.toValidate.querySelector('input[name="' + field.dataset.comparison + '"]');

                    if (fieldToCompare) {
                        if (field.value === fieldToCompare.value) {
                            passed = true;
                        } else {
                            message = field.dataset.validatorMessage || 'Hasła są różne';
                        }
                    }
                } else {
                    const otherField = this.toValidate.querySelector('input[data-comparison]');

                    if (otherField) {
                        this.processField(otherField);
                    }
                }

                return {
                    passed: passed,
                    message: message
                };
            }
        }
    }

    toValidateList.forEach(toValidate => new Validator(toValidate));
}